<template>
  <b-card>
    <div slot="header">
      <i
        class="fa fa-list-ul"
        aria-hidden="true"
      ></i>
    </div>
    <b-row>
      <b-col sm="12">
        <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
        <b-table
          stacked="sm"
          :busy="isBusy"
          :current-page="currentPage"
          :per-page="numberPerPage"
          class="table-app"
          tbody-class="tbody"
          hover
          thead-tr-class="thead-app"
          selectedVariant="single"
          :filter="keyword"
          :fields="fields"
          :items="userItemsProvider"
          @row-clicked='getProjectProfile'
        >
            <template slot="background" slot-scope="data">
                <b-img :src="data.item.background" width="420px" height="80px"></b-img>
            </template>
          <div
            slot="table-busy"
            class="text-center text-dark my-2"
          >
            <b-spinner
              variant="dark"
              class="align-middle"
            ></b-spinner>
            <strong>Loading...</strong>
          </div>
        </b-table>
        <hr />
        <b-row>
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="numberPerPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import AlertFail from '@/components/alert/AlertFail';
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';
import MqdcOneClient from '@/models/mqdc-one-client';
import { textProject } from '@/assets/utils/language';

export default {
  data () {
    return {
      isBusy: false,
      numberPerPage: 10,
      fields: [],
      usersList: [],
      isError: false,
      errorMessage: '',
      currentPage: 1,
      totalRows: 1,
      authenticated: false,
      keyword: '',
      keywordText: '',
      headerText: 'Projects',
      title: 'One App: Projects',
      mqdcOneClient: {},
      text: {}
    };
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.text = textProject(this.$language);
    this.refreshTableField();
  },
  methods: {
    /// Items Provider for b-table
    async userItemsProvider (ctx) {
      try {
        let getUrl = process.env.VUE_APP_URL_MQDCONE_API + '/mqdc-one/projects';
        const promise = this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(
            getUrl
          )
          ;
        });

        return promise.then(data => {
          const projects = data.data.data;

          const projectItems = [];
          for (const project of projects) {
            let projectRaw = {
              id: project.id,
              name: project.name,
              code: project.code,
              background: project.background,
              phoneNumber: project.phoneNumber,
              juristicNumber: project.juristicNumber,
              contactEmail: project.contactEmail,
              createdAt: project.createdAt !== null ? this.toLocalDateTime(project.createdAt.timestamp) : null,
              updatedAt: project.updatedAt !== null ? this.toLocalDateTime(project.updatedAt.timestamp) : null
            };
            projectItems.push(projectRaw);
          }
          this.totalRows = projectItems.length;
          // Must return an array of items or an empty array if an error occurred
          return projectItems || [];
        });
      } catch (err) {
        return [];
      }
    },
    toLocalDateTime (dt) {
      return dateToStringWithTimeFull(new Date(dt * 1000));
    },
    errorHandler (error) {
      console.log(error);
      this.errorMessage = error.message;
      if (error.message) {
        this.errorMessage = error.message;
        this.isError = true;
      }
    },
    refreshTableField () {
      this.fields = [
        { key: 'name', label: this.text.name },
        { key: 'code', label: this.text.code },
        { key: 'background', label: this.text.background },
        { key: 'phoneNumber', label: this.text.phoneNumber },
        { key: 'juristicNumber', label: this.text.juristicNumber },
        { key: 'contactEmail', label: this.text.contactEmail },
        { key: 'createdAt', label: this.text.createdAt },
        { key: 'updatedAt', label: this.text.updatedAt }
      ];
    },
    async getProjectProfile (row) {
      this.$router.push({ name: 'one_app_projects-project', params: { code: row.code } });
    }
  },
  components: {
    AlertFail
  },
  created () {
    document.title = this.title;
  },
  watch: {
    $language: function () {
      this.text = textProject(this.$language);
      this.refreshTableField();
    }
  }
};
</script>
